export default {
	computed: {
		isMobile() {
			return this.$store.getters.getWindowWidth < 1024;
		},
	},
};
